module.exports = __webpack_public_path__ + "img/map-location.7bee14fe.png";